import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BaseComponent } from 'src/app/moov-common/base/base.component';

@Component({
  selector: 'app-structured-process-external-info',
  templateUrl: './structured-process-external-info.component.html',
  styleUrls: ['./structured-process-external-info.component.scss']
})
export class StructuredProcessExternalInfoComponent extends BaseComponent {
  @Input() externalUrl: string = '';

  iframeSrcSafe!: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    const url = new URL(this.externalUrl);
    if (url.protocol !== 'https:') {
      throw new Error('Blocked unexpected iframe URL');
    }
    this.iframeSrcSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url.toString());
  }
}
